import { StackLayout } from '@euler/app/components/StackLayout';
import { Typography } from '@euler/app/components/typography';
import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { ClearableNumberInput } from '@euler/components/NumberInput';
import { FormGroup } from '@euler/components/form';
import { useBaseInputStyle } from '@euler/components/form/Input';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useCallback } from 'react';
import { StyleProp, TextStyle } from 'react-native';

export const MileageRangeField = memo(() => {
  const { rpx } = useResponsiveContext();
  const { form } = useOrderSearchForm();
  const baseStyle = useBaseInputStyle();

  const inputStyle: StyleProp<TextStyle> = [
    {
      backgroundColor: '#fff',
      borderRadius: baseStyle.borderRadius,
      borderWidth: baseStyle.borderWidth,
      padding: baseStyle.padding,
      fontSize: baseStyle.fontSize,
      borderColor: baseStyle.borderColor,
      flex: 1,
    },
  ];

  const focusedInputStyle: StyleProp<TextStyle> = {
    borderColor: baseStyle.borderColorFocused,
  };

  const onLowerChange = useCallback(
    (value: number | undefined) => {
      form.mileage.update({
        ...form.mileage.value,
        start: value,
        startInclusive: value == null ? undefined : true,
      });
    },
    [form.mileage],
  );

  const onUpperChange = useCallback(
    (value: number | undefined) => {
      form.mileage.update({
        ...form.mileage.value,
        end: value,
        endInclusive: value == null ? undefined : true,
      });
    },
    [form.mileage],
  );

  return (
    <FormGroup label="行驶里程">
      <StackLayout
        direction="row"
        gap={rpx(4)}
        alignItems="center"
        divider={<Typography.Text>→</Typography.Text>}
      >
        <ClearableNumberInput
          value={form.mileage.value?.start}
          placeholder="开始里程"
          style={inputStyle}
          focusedStyle={focusedInputStyle}
          placeholderTextColor={baseStyle.placeholderTextColor}
          keyboardType="number-pad"
          clearButtonMode="always"
          withNativeClearButton={false}
          onChangeValue={onLowerChange}
        />
        <ClearableNumberInput
          value={form.mileage.value?.end}
          placeholder="结束里程"
          style={inputStyle}
          focusedStyle={focusedInputStyle}
          placeholderTextColor={baseStyle.placeholderTextColor}
          keyboardType="number-pad"
          clearButtonMode="always"
          withNativeClearButton={false}
          onChangeValue={onUpperChange}
        />
      </StackLayout>
    </FormGroup>
  );
});
